import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const referrals = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return referrals.get("/referrals?" + qstr);
  },
  delete(id) {
    return referrals.delete("/referrals/" + id);
  },
  create(inputs) {
    return referrals.post("/referrals", inputs);
  },
  find(id) {
    return referrals.get("/referrals/" + id);
  },
  update(id, inputs) {
    return referrals.put("/referrals/" + id, inputs);
  },
  getGiftType() {
    return referrals.get("/settings/referral_gift_type");
  },
  getActive() {
    return referrals.get("/referrals/current");
  },
  getHistory(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return referrals.get("referrals/history?" + qstr);
  },
  getCurrent() {
    return referrals.get("/referrals/current");
  },
  getAdvocateDetail(id, qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return referrals.get("/referrals/advocates/"+id+"/rewards?" + qstr);
  },
  confirmAdvocare(id, inputs){
    return referrals.post("/referrals/advocates/rewards/" + id , inputs);
  }
};
